import {Component, OnInit} from '@angular/core';
import {ProjectsService} from "../../../services/projects.service";
import {environment} from "../../../../../environments/environment";
import {CoreService} from "../../../services/core.service";

@Component({
  selector: 'app-thank-you-datagate',
  templateUrl: './thank-you-datagate.component.html',
  styleUrls: ['./thank-you-datagate.component.sass']
})
export class ThankYouDatagateComponent {
  constructor(
    private coreService: CoreService
  ) {
    this.coreService.enableThankYouPage();
  }

} 